import React from 'react';
import styled from 'styled-components';

const Section = styled.div`
  margin: 60px 0;
`;

const Title = styled.h2`
  font-family: var(--font-serif);
  font-size: 2rem;
  color: var(--color-text);
  margin-bottom: 40px;
  text-align: center;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 32px;
`;

const Card = styled.div`
  background: white;
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 12px;
  padding: 32px;
  transition: all 0.3s ease;

  &:hover {
    border-color: var(--color-primary-blue);
    transform: translateY(-5px);
  }
`;

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  background: #f1f5f9;
  color: var(--color-primary-blue);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

const CardTitle = styled.h3`
  font-family: var(--font-serif);
  font-size: 1.25rem;
  margin-bottom: 12px;
  color: var(--color-text);
`;

const CardDesc = styled.p`
  color: var(--color-text-light);
  line-height: 1.6;
  font-size: 0.95rem;
`;

const KeyTakeaways = ({ items }) => (
  <Section>
    <Title>Highlights</Title>
    <Grid>
      {items.map((item, index) => (
        <Card key={index}>
          <IconWrapper>
            {item.icon}
          </IconWrapper>
          <CardTitle>{item.title}</CardTitle>
          <CardDesc>{item.description}</CardDesc>
        </Card>
      ))}
    </Grid>
  </Section>
);

export default KeyTakeaways;